import * as React from 'react';
import { t } from 'i18next';

import { OAPClasses } from './OAPClasses';
import { SelectBoxOption } from '../../../stores/SelectBoxStore';
import { BasePopupMenuIcon } from '../BasePopupMenuIcon';
import { OAPActions } from '../../../actions/OAPActions';
import { BasePopupMenuTitleSetting } from '../BasePopupMenuHeader';
import { OAPLevel } from '../../../stores/OAPStore';
import { VisibilityActions } from '../../../actions/VisibilityActions';
import { PropertyEditorActions } from '../../../actions/PropertyEditorActions';

import core = egr.wcf.core;
import utils = egr.wcf.utils;

export class OAPValues extends OAPClasses {
    protected options = (): Array<SelectBoxOption> => {
        const currentValue: core.prop.PropertyValue | null = this.props.selectedProperty != null ? this.props.selectedProperty.getValue() : null;
        if (
            this.props.values.length === 0 &&
            this.props.selectedProperty != null &&
            !this.props.selectedProperty.choiceList &&
            this.props.selectedProperty.allowCustomChoice
        ) {
            const property: core.prop.Property = this.props.selectedProperty;
            let type: 'text' | 'number' = 'text';
            const stringValue: string | null = this.props.selectedProperty.getValueAsString();
            let defaultValue: string | number | null = this.props.selectedProperty.getValueAsString();
            if ((this.props.selectedProperty instanceof core.prop.NumberProperty) ||
                (this.props.selectedProperty instanceof core.prop.LengthProperty)
            ) {
                type = 'number';
                if (utils.string.isNotNullOrEmpty(stringValue)) {
                    defaultValue = parseInt(stringValue, 10);
                }
            }
            return [{
                name: utils.string.isNotNullOrEmpty(stringValue) ? `${property.getName()}: ${stringValue}` : t('Different value'),
                value: 'custom-input',
                className: 'egr-select-option-no-icon',
                callback: () => {
                    VisibilityActions.setDialog({
                        callback: (newValue: any): void => {
                            PropertyEditorActions.setPropertyValue(property, newValue);
                            OAPActions.hideDialog();
                        },
                        label: property.getName(),
                        default: defaultValue,
                        type
                    });
                },
            }];
        }

        let iconsAvailable: boolean = false;
        const result: Array<SelectBoxOption> = this.props.values.map((value, index): SelectBoxOption => {
            let className: string = '';
            let icon: JSX.Element | null = null;
            if (!utils.string.isNullOrEmpty(value.smallIcon) && value.text !== 'ohne') {
                icon = <BasePopupMenuIcon key="icon" src={value.smallIcon}/>;
                iconsAvailable = true;
            }

            const active: boolean = (
                currentValue != null &&
                value != null &&
                currentValue.value === value.value
            );

            if (active) {
                className += ' egr-select-option-selected';
            }

            return {
                name: utils.string.isNullOrEmpty(value.text) ? '' : value.text,
                value: index + '-ch',
                className: className,
                callback: async () => {
                    if (!active && this.props.selectedProperty != null) {
                        const changeResult: core.prop.PropertyChangedResult = await OAPActions.setValue(this.props.selectedProperty, value.value);
                        if (changeResult !== core.prop.PropertyChangedResult.Nothing) {
                            OAPActions.hideDialog();
                        }
                    }
                },
                extraButtons: icon == null ? undefined : [icon]
            };
        });
        if (iconsAvailable) {
            return result;
        }
        return result.map((value) => {
            value.className += ' egr-select-option-no-icon';
            return value;
        });
    };

    protected title = (): BasePopupMenuTitleSetting => {
        if (utils.string.isNullOrEmpty(this.props.title)) {
            return {label: ''};
        }
        if (this.props.startLevel < OAPLevel.Values) {
            return {label: this.props.title, className: 'egr-select-option-header-back', callback: async () => {
                OAPActions.setSelectedProperty(null);
            }};
        }
        return {label: this.props.title, className: '', callback: () => {
            OAPActions.hideDialog();
        }};
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/OAP/OAPValues.tsx